export type HoroscopeFocuses = Array<{
  name: string;
  percent: number;
}>;

export type DailyHoroscope = {
  period: 'today';
  focuses: HoroscopeFocuses;
  date: string;
  essentials: string;
  text: string;
};

export enum DailyHoroscopeComponentType {
  HOROSCOPE = 'horoscope',
  YES_AND_NO = 'yes_and_no',
  TIP = 'tip',
  SCORING = 'scoring',
}
